import { MessageCircle } from 'lucide-react'

export function EmptyChatState() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <MessageCircle className="h-8 w-8 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-semibold mb-1">No conversations yet</h2>
      <p className="text-sm text-muted-foreground max-w-xs">
        Tap the pencil icon above to start chatting with someone.
      </p>
    </div>
  )
}
